import axios from "axios";
import { warehouseImagesBaseUrl } from "./utils/env";

export default axios.create({
  baseURL: warehouseImagesBaseUrl,
});
